import { render, staticRenderFns } from "./im-card.vue?vue&type=template&id=af55257e&scoped=true&"
import script from "./im-card.vue?vue&type=script&lang=js&"
export * from "./im-card.vue?vue&type=script&lang=js&"
import style0 from "./im-card.vue?vue&type=style&index=0&id=af55257e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af55257e",
  null
  
)

export default component.exports